import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";

const ModalProductSelector = ({ query, onSelect }) => {
  const [searchText, setSearchText] = useState("");
  const { loading, error, data } = useQuery(query);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const products = data.products.results
    .filter((product) =>
      searchByProp(product, ["name", "number", "odooId"], searchText),
    )
    .sort((a, b) => a.number.replace(/\D/g, "") - b.number.replace(/\D/g, ""));

  return (
    <div>
      <div>
        <SearchBar
          value={searchText}
          onChange={setSearchText}
          placeholder="Search product by name or number."
        />
      </div>
      <div className="mt-2 text-sm whitespace-nowrap">
        {products.map((product, index) => (
          <div
            key={index}
            className="cursor-pointer border-b dark:border-gray-700 hover:bg-blue-100 py-2 space-y-2"
            onClick={() => onSelect(product)}
          >
            <div>
              <div className="opacity-70 text-xs">W#{product.id}</div>
              <div>
                [{product.number}] {product.name}
              </div>
            </div>

            {product.images && product.images.length > 0 && (
              <div className="flex space-x-2">
                {product.images.map((i, index) => (
                  <img className="h-8" key={index} src={i.url} alt={i.id} />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ModalProductSelector;
